import variables from '../scss/abstract/_all.module.scss';
import { center } from './Utilities/flex';

export const theme = {
  Colors: {
    primary: variables.primary,
    secondary: variables.secondary,
    active: variables.active,
    inactive: variables.inactive,
    highlight: variables.active,
    selected: variables.selected,
    neutral: variables.lightBlueGrey,
    success: variables.success,
    successLight: variables.green25,
    warning: variables.warning,
    warningLight: variables.yellow25,
    danger: variables.danger,
    dangerLight: variables.red25,
    info: variables.info,
    link: variables.link,
    dark: variables.dark,
    white: variables.white,
    secondary: variables.secondary,
    slateGrey: variables.slateGrey,
    logo: variables.logo,
    activeBlue: variables.activeBlue,
    Secondary: {
      main: variables.secondary,
      active: variables.secondaryActive,
      inactive: variables.secondaryInactive,
    },
    Backgrounds: {
      subtle: variables.subtle,
      web: variables.webGray,
      lighter: variables.veryLightBlue,
      lighter50: variables.veryLightBlue50,
      accent25: variables.paleBlue25,
      info25: variables.info25,
      toast: variables.toast,
      leftNavigation: variables.darkBlue,
      studentPlayer: variables.veryLightGray,
      mediumLightGray: variables.mediumLightGray,
      recommendations: variables.lightBlue,
    },
    Brand: {
      normal: variables.brand,
      active: variables.brandActive,
      inactive: variables.brandInactive,
      hover: variables.brandHover,
      disabled: variables.brandDisabled,
    },
    Indicator: {
      normal: variables.indicator,
      hover: variables.indicatorHover,
      light: variables.indicatorLight,
      dark: variables.red100,
    },
    Shadows: {
      light: variables.shadowLight,
    },
    Curriculum: {
      eureka: variables.eureka,
      eurekaMath: variables.eurekaMath,
      eurekaMath25: variables.eurekaMath25,
      eurekaAction: variables.eurekaAction,
      eurekaHover: variables.eurekaHover,
      eurekaActive: variables.eurekaActive,
      eurekaInactive: variables.eurekaInactive,
      eurekaDisabled: variables.eurekaDisabled,
      witAndWisdom: variables.witAndWisdom,
      witAndWisdom25: variables.witAndWisdom25,
      history: variables.history,
      em: {
        main: variables.eurekaMath,
        light: variables.eurekaLight,
        action: variables.eurekaAction,
        hover: variables.eurekaHover,
        active: variables.eurekaActive,
        inactive: variables.eurekaInactive,
        disabled: variables.eurekaDisabled,
        highlyProficient: variables.eurekaHighlyProficient,
        proficient: variables.eurekaProficient,
        partial: variables.eurekaPartial,
        notYet: variables.eurekaNotYet,
        none: variables.eurekaNone,
        empty: variables.eurekaEmpty,
      },
      ww: {
        main: variables.witAndWisdom,
        light: variables.witAndWisdomLight,
        action: variables.witAndWisdomAction,
        hover: variables.witAndWisdomHover,
        active: variables.witAndWisdomActive,
        inactive: variables.witAndWisdomInactive,
        disabled: variables.witAndWisdomDisabled,
        bandA: variables.witAndWisdomBandA,
        bandB: variables.witAndWisdomBandB,
        bandC: variables.witAndWisdomBandC,
        bandD: variables.witAndWisdomBandD,
        bandE: variables.witAndWisdomBandE,
        bandF: variables.witAndWisdomBandF,
      },
      phd: {
        main: variables.phdScience,
        light: variables.phdScienceLight,
        action: variables.phdScienceAction,
        hover: variables.phdScienceHover,
        active: variables.phdScienceActive,
        inactive: variables.phdScienceInctive,
        disabled: variables.phdScienceDisabled,
      },
      //geo was temporarily set to EM default values
      geo: {
        main: variables.eurekaMath,
        light: variables.eurekaLight,
        action: variables.eurekaAction,
        hover: variables.eurekaHover,
        active: variables.eurekaActive,
        inactive: variables.eurekaInactive,
        disabled: variables.eurekaDisabled,
        highlyProficient: variables.eurekaHighlyProficient,
        proficient: variables.eurekaProficient,
        partial: variables.eurekaPartial,
        notYet: variables.eurekaNotYet,
        none: variables.eurekaNone,
        empty: variables.eurekaEmpty,
      },
    },
    Typography: {
      primary: variables.dark,
      secondary: variables.darkGray,
      hint: variables.hint,
    },
    Borders: {
      accent: variables.darkGray,
      hint: variables.hint,
      studentPlayer: variables.mediumGray,
    },
    Neo: {
      dark: variables.dark,
    },
  },
  Typography: {
    fontFamily: variables.fontFamilyBase,
    sansFontFamily: variables.fontFamilySans,
    quicksandFontFamily: variables.fontFamilyQuicksand,
    Sizes: {
      xs: variables.extraSmallFontSize,
      sm: variables.smallFontSize,
      smd: variables.smallMediumFontSize,
      md: variables.mediumFontSize,
      lg: variables.largeFontSize,
      xl: variables.extraLargeFontSize,
      xxl: variables.extraExtraLargeFontSize,
    },
    Weights: {
      normal: variables.normalFontWeight,
    },
  },
  Iconology: {
    Sizes: {
      sm: variables.smallIconSize,
      md: variables.mediumIconSize,
    },
  },
  Shadows: {
    modal: variables.modalShadow,
  },
  Spacing: {
    x1: variables.spx1,
    x2: variables.spx2,
    x3: variables.spx3,
    x4: variables.spx4,
    x5: variables.spx5,
    x6: variables.spx6,
    x7: variables.spx7,
  },
  Dimensions: {
    Borders: {
      default: variables.borderWidthx1,
      x1: variables.borderWidthx1,
      x2: variables.borderWidthx2,
      x3: variables.borderWidthx3,
      x4: variables.borderWidthx4,
      x5: variables.borderWidthx5,
      x6: variables.borderWidthx6,
      x7: variables.borderWidthx7,
      Radiuses: {
        light: variables.lightBorderRadius,
        medium: variables.mediumBorderRadius,
        strong: variables.strongBorderRadius,
        stronger: variables.strongerBorderRadius,
        circle: variables.circleBorderRadius,
      },
    },
  },
  Textures: {
    Borders: {
      active: variables.solidBorderTexture,
    },
  },
  Utilities: {
    Flex: {
      center,
    },
  },
  Breakpoints: {
    tabletPortrait: variables.tabletPortrait,
    mobile: variables.mobile,
    tablet: variables.tablet,
    tabletXL: variables.tabletXL,
    laptop: variables.laptop,
    desktop: variables.desktop,
  },
};

function build() {
  return theme;
}

export default build;
